module.exports = __webpack_public_path__ + "static/straight-long-shape-1d316da7d3b6cdb40b5d2ba591c04db8.svg";